import React from 'react';
import HelpArticle from './HelpArticle';

const ExternalIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const PressDetail = ({ item, backTo }) => (
  <HelpArticle
    tab="newsroom"
    backTo={backTo}
    date={item.date}
    title={item.title}
    badges={item.sources?.length > 0 && (
      <div className="help-press-sources">
        <span className="help-press-sources__label">보도 매체</span>
        {item.sources.map(source => (
          <a
            key={source.name}
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="help-press-sources__link"
          >
            {source.name}
            <ExternalIcon />
          </a>
        ))}
      </div>
    )}
  >
    <div
      className="help-article__content help-press-detail__body"
      dangerouslySetInnerHTML={{ __html: item.content }}
    />
  </HelpArticle>
);

export default PressDetail;
